import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M10.25 21.09a7.53 7.53 0 0 1-7.53-7.53C2.72 2.64 15.86 8.25 22.19 3a.46.46 0 0 1 .48 0 .51.51 0 0 1 .3.38c1.93 11.26-6.4 17.71-12.72 17.71" }),
      createElementVNode("path", { d: "M13.26 11.55a25 25 0 0 0-8.61 4.29l-3.9 3.33" })
    ], -1)
  ]));
}
const natureEcologyLeaf = { render };
export {
  natureEcologyLeaf as default,
  render
};
//# sourceMappingURL=nature-ecology-leaf.svg.js.map
